// src/store/api/studentApiSlice.js
import { apiSlice } from "./apiSlice";

export const studentApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// Get all students (including inactive) - for admin view
		getAllStudentsIncludingInactive: builder.query({
			query: () => "/Student/all",
			providesTags: ["Students"],
		}),

		// Get only active students (backwards compatibility)
		getAllStudents: builder.query({
			query: () => "/Student",
			providesTags: ["Students"],
		}),

		// Get students by department
		getStudentsByDepartment: builder.query({
			query: (departmentId) => `/Student/department/${departmentId}`,
			providesTags: (result, error, departmentId) => [
				{ type: "Students", id: departmentId },
			],
		}),

		// Get all students by department (including inactive)
		getAllStudentsByDepartment: builder.query({
			query: (departmentId) => `/Student/department/${departmentId}/all`,
			providesTags: (result, error, departmentId) => [
				{ type: "Students", id: `${departmentId}-all` },
			],
		}),

		// Get student by ID
		getStudentById: builder.query({
			query: (id) => `/Student/${id}`,
			providesTags: (result, error, id) => [{ type: "Students", id }],
		}),

		// Create new student
		createStudent: builder.mutation({
			query: (studentData) => ({
				url: "/Student",
				method: "POST",
				body: studentData,
			}),
			invalidatesTags: ["Students"],
		}),

		// Update student
		updateStudent: builder.mutation({
			query: ({ id, ...studentData }) => ({
				url: `/Student/${id}`,
				method: "PUT",
				body: studentData,
			}),
			invalidatesTags: (result, error, { id }) => [
				"Students",
				{ type: "Students", id },
			],
		}),

		// Update student status - FIXED
		updateStudentStatus: builder.mutation({
			query: ({ id, isActive }) => ({
				url: `/Student/${id}/status`,
				method: "PATCH",
				body: JSON.stringify(isActive),
				headers: {
					"Content-Type": "application/json",
				},
			}),
			invalidatesTags: (result, error, { id }) => [
				"Students",
				{ type: "Students", id },
			],
		}),

		// Delete student
		deleteStudent: builder.mutation({
			query: (id) => ({
				url: `/Student/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["Students"],
		}),
	}),
});

export const {
	useGetAllStudentsIncludingInactiveQuery,
	useGetAllStudentsQuery,
	useGetStudentsByDepartmentQuery,
	useGetAllStudentsByDepartmentQuery,
	useGetStudentByIdQuery,
	useCreateStudentMutation,
	useUpdateStudentMutation,
	useUpdateStudentStatusMutation,
	useDeleteStudentMutation,
} = studentApiSlice;
